// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__BQycm","Error":"Input_Error__rx58_"};